{
  "Accessibility Menu": "ప్రాప్యత మెనూ",
  "Reset settings": "సెట్టింగ్‌లను రీసెట్ చేయండి",
  "Close": "మూసివేయి",
  "Content Adjustments": "కంటెంట్ సర్దుబాట్లు",
  "Adjust Font Size": "ఫాంట్ పరిమాణాన్ని సర్దుబాటు చేయండి",
  "Highlight Title": "శీర్షికను హైలైట్ చేయండి",
  "Highlight Links": "లింక్‌లను హైలైట్ చేయండి",
  "Readable Font": "చదవడానికి అనుకూలమైన ఫాంట్",
  "Color Adjustments": "రంగు సర్దుబాట్లు",
  "Dark Contrast": "చీకటి వ్యత్యాసం",
  "Light Contrast": "తెల్లటి వ్యత్యాసం",
  "High Contrast": "అధిక వ్యత్యాసం",
  "High Saturation": "అధిక సంతృప్తి",
  "Low Saturation": "తక్కువ సంతృప్తి",
  "Monochrome": "మోనోక్రోమ్",
  "Tools": "పరికరాలు",
  "Reading Guide": "చదవడం మార్గదర్శకుడు",
  "Stop Animations": "యానిమేషన్‌లను ఆపు",
  "Big Cursor": "పెద్ద కర్సర్",
  "Increase Font Size": "ఫాంట్ పరిమాణాన్ని పెంచండి",
  "Decrease Font Size": "ఫాంట్ పరిమాణాన్ని తగ్గించండి",
  "Letter Spacing": "అక్షరాల మధ్య ఖాళీ",
  "Line Height": "లైన్ ఎత్తు",
  "Font Weight": "ఫాంట్ బరువు",
  "Dyslexia Font": "డిస్లెక్సియా ఫాంట్",
  "Language": "భాష",
  "Open Accessibility Menu": "ప్రాప్యత మెనూను తెరవండి"
}
